import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

const plans = [
  {
    name: 'Free',
    price: '$0',
    description: 'Perfect for getting started',
    features: [
      'Basic calculator functionality',
      'DTF and screen printing support',
      'Unlimited quotes',
      'Basic customization',
      'Shareable calculator URL'
    ]
  },
  {
    name: 'Premium',
    price: '$9',
    period: '/month',
    description: 'For professional print shops',
    features: [
      'Everything in Free, plus:',
      'Custom domain support',
      'Custom color themes',
      'Custom logo & branding',
      'Priority support',
      'Advanced analytics (coming soon)'
    ],
    highlight: true
  }
];

export function Pricing() {
  return (
    <div className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h1 className="text-4xl font-bold tracking-tight text-default sm:text-5xl">
            Simple, transparent pricing
          </h1>
          <p className="mt-6 text-lg leading-8 text-muted">
            Choose the plan that works best for your print shop
          </p>
        </div>
        <div className="isolate mx-auto mt-16 grid max-w-6xl grid-cols-1 gap-8 sm:mt-20 lg:grid-cols-2">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`rounded-3xl p-8 ring-1 ${
                plan.highlight 
                  ? 'bg-[var(--color-brand-primary)]/5 ring-[var(--color-brand-primary)]' 
                  : 'bg-[var(--color-bg-card)] ring-[var(--color-border)]'
              }`}
            >
              <h2 className={`text-2xl font-bold tracking-tight ${plan.highlight ? 'text-[var(--color-brand-primary)]' : 'text-default'}`}>
                {plan.name}
              </h2>
              <p className="mt-4 text-sm leading-6 text-muted">{plan.description}</p>
              <p className="mt-6 flex items-baseline gap-x-1">
                <span className="text-4xl font-bold tracking-tight text-default">{plan.price}</span>
                {plan.period && (
                  <span className="text-sm font-semibold leading-6 text-muted">{plan.period}</span>
                )}
              </p>
              <Link
                to="/signup"
                state={{ plan: plan.name.toLowerCase() }}
                className={`mt-6 block rounded-md px-3 py-2 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                  plan.highlight
                    ? 'bg-[var(--color-brand-primary)] text-white hover:bg-[var(--color-brand-primary)]/90 focus-visible:outline-[var(--color-brand-primary)]'
                    : 'bg-[var(--color-bg-card)] text-default ring-1 ring-inset ring-[var(--color-border)] hover:ring-[var(--color-brand-primary)]'
                }`}
              >
                Get started
              </Link>
              <ul role="list" className="mt-8 space-y-3 text-sm leading-6 text-muted">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex gap-x-3">
                    <Check className="h-6 w-5 flex-none text-[var(--color-brand-primary)]" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}